module.exports = __webpack_public_path__ + "static/media/AGILITY_COLOUR.c04671d7.png";